/**
 * Logo oficial. El archivo sale de socioambientales.com.ar sin retocar; los
 * colores de la interfaz derivan de sus pixeles (ver index.css).
 */
export function Logo({ className = 'h-9 w-auto' }: { className?: string }) {
  return (
    <img
      src="/logo-dm.png"
      alt="Socioambientales DM"
      className={className}
      width={711}
      height={665}
    />
  );
}

/** Logo con el nombre al lado, para las barras superiores. */
export function MarcaHorizontal({ subtitulo }: { subtitulo?: string }) {
  return (
    <div className="flex items-center gap-2.5">
      <Logo className="h-8 w-auto" />
      <span className="leading-tight">
        <span className="block text-sm font-semibold tracking-tight text-marca-700">
          Socioambientales DM
        </span>
        {subtitulo && (
          <span className="block text-xs text-slate-500">{subtitulo}</span>
        )}
      </span>
    </div>
  );
}
